export const OBJECT_TYPE = {
  CAMPAIGN: '0-35',
  MARKETING_EMAIL: '0-29',
  MARKETING_EVENT: '0-54',
  FORM: '0-28',
  MARKETING_SMS: '0-124',
  CONTENT: '0-10',
  FEEDBACK_SURVEY: '0-111'
};